import { BCMSDate } from "@bcm-dev/bcms-vite";
import { useState } from "react";
import { SVGAsset } from "res";
import Month from "../Month";
import PickerHeader from "../PickerHeader";

export default function DoubleCalendar(props) {
    const [viewDate, setViewDate] = useState( BCMSDate.init(props.setDate).setToFirst().date);

    const currentMonth = BCMSDate.init();
    const isSameMonth = currentMonth.monthInt == BCMSDate.init(viewDate).monthInt;

    let month1,
        month2;

    if(isSameMonth || BCMSDate.init(viewDate).isBefore(currentMonth)) {
        month1 = BCMSDate.init(viewDate);
        month2 = BCMSDate.init(viewDate).offset([ 0, 1, 0 ]);
    }
    else {
        month1 = BCMSDate.init(viewDate).offset([ 0, -1, 0 ]);
        month2 = BCMSDate.init(viewDate);
    }

    const  close = props.controllers.close;
    
    return(      
        <div className="date-picker flex-container flex-vertical">
            <div className="close-icon-container flex-container flex-horizontal align-center justify-right link clickable" onClick={close}><SVGAsset id="CloseIcon" className="icon" /></div>
            <div className="row"><PickerHeader month1={month1} month2={month2} setViewDate={setViewDate} disabled={props.disabled} /></div> 
            <div className="calendar-wrapper flex-container flex-horizontal">
                <Month viewDate={month1} setDate={props.setDate} onChange={props.onChange} controllers={props.controllers}/>
                <div className="divider"/>
                <Month viewDate ={month2} onChange={props.onChange} setDate={props.setDate} controllers={props.controllers}/>
            </div>
        </div>                
    )
} 